import {
  ADD_EMAIL,
  ADD_EMAIL_FAILURE,
  ADD_EMAIL_SUCCESS,
  CANCEL_ACCOUNT_DELETION,
  CANCEL_ACCOUNT_DELETION_FAILURE,
  CANCEL_ACCOUNT_DELETION_SUCCESS,
  DELETE_ACCOUNT,
  DELETE_ACCOUNT_FAILURE,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_EMAIL,
  DELETE_EMAIL_FAILURE,
  DELETE_EMAIL_SUCCESS,
  GET_ACCOUNT_DELETE_STATUS,
  GET_ACCOUNT_DELETE_STATUS_FAILURE,
  GET_ACCOUNT_DELETE_STATUS_SUCCESS,
  GET_USER_EMAILS,
  GET_USER_EMAILS_FAILURE,
  GET_USER_EMAILS_SUCCESS,
  LOGIN_PROFILE_CREATED_RESET,
  MAKE_EMAIL_DEFAULT,
  MAKE_EMAIL_DEFAULT_FAILURE,
  MAKE_EMAIL_DEFAULT_SUCCESS,
  REQUEST_USER_PROFILE,
  REQUEST_USER_PROFILE_FAILURE,
  REQUEST_USER_PROFILE_SUCCESS,
} from "../../modules/constants";
import { createNotification } from "../../modules/notificationManager";

// ------------------------------------
// Action handler methods
// ------------------------------------
export const profileRequestHandler = (state, action) => {
  if (action.payload.method && action.payload.method === "GET") {
    return {
      ...state,
      isLoading: true,
      profileDataError: "",
    };
  }
  return {
    ...state,
    updateIsLoading: true,
    profileDataError: "",
  };
};
export const profileRequestSuccessHandler = (state, action) => {
  const {
    payload: { data, notify, timezoneOffset },
  } = action;
  if (
    state.profileData &&
    state.profileData.id &&
    data &&
    data.user_id &&
    state.profileData.id !== data.user_id
  ) {
    createNotification("success", "Contact number updated.", 3000);
    return {
      ...state,
      isLoading: false,
      updateIsLoading: false,
      profileDataError: "",
    };
  }
  if (data.status === 200) {
    localStorage.setItem(
      "user_fullName",
      `${data.data.first_name}${
        data.data.last_name ? ` ${data.data.last_name}` : ``
      }`,
    );
    if (notify === true) {
      createNotification("success", "Profile updated.", 3000);
      if (data.data && data.data.timezone && timezoneOffset) {
        localStorage.setItem(
          "user_timezone",
          JSON.stringify({
            tz: data.data.timezone,
            offset: timezoneOffset,
          }),
        );
      }
      return {
        ...state,
        isLoading: false,
        updateIsLoading: false,
        redirect: state.redirect + 1,
        profileData: data.data,
        profileDataError: "",
      };
    }
    return {
      ...state,
      isLoading: false,
      updateIsLoading: false,
      profileData: data.data,
      profileDataError: "",
    };
  }
  return {
    ...state,
    redirect: state.redirect + 1,
    isLoading: false,
    updateIsLoading: false,
    profileDataError: "",
  };
};
export const profileRequestFailureHandler = (state, action) => {
  const {
    payload: { response },
  } = action;
  if (response && response.status === 400 && response.data.phone) {
    createNotification("error", "Invalid contact number.", 3000);
    return {
      ...state,
      isLoading: false,
      updateIsLoading: false,
      profileDataError: "Invalid contact number",
    };
  }
  createNotification("error", "Error! Try again.", 3000);
  return {
    ...state,
    isLoading: false,
    updateIsLoading: false,
    profileDataError: "Something went wrong!",
  };
};

export const handleDeleteAccount = (state, action) => {
  return {
    ...state,
    deleteAccountLoading: true,
  };
};
export const handleDeleteAccountSuccess = (state, action) => {
  const {
    payload: { data, notify },
  } = action;
  if (data.status === 200) {
    if (notify === true) {
      createNotification("success", `${data.data.success}.`, 3000);
      return {
        ...state,
        deleteAccountLoading: false,
        redirect: state.redirect + 1,
      };
    }
    return {
      ...state,
      deleteAccountLoading: false,
    };
  }
  return {
    ...state,
    redirect: state.redirect + 1,
    deleteAccountLoading: false,
  };
};
export const handleDeleteAccountFailure = (state, action) => {
  if (action.payload.response) {
    if (action.payload.response.data && action.payload.response.data.failure) {
      createNotification(
        "error",
        `${action.payload.response.data.failure}.`,
        3000,
      );
    } else {
      createNotification("error", "Something went wrong!", 3000);
    }
  } else {
    createNotification("error", "Please check your internet connection.", 3000);
  }
  return {
    ...state,
    deleteAccountLoading: false,
  };
};

export const handleGetUserEmails = (state, action) => {
  return {
    ...state,
    isLoading: true,
  };
};
export const handleGetUserEmailsSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      isLoading: false,
      userEmails: data.data,
    };
  }
  return {
    ...state,
    isLoading: false,
    userEmails: null,
  };
};
export const handleGetUserEmailsFailure = (state, action) => {
  return {
    ...state,
    isLoading: false,
    userEmails: null,
  };
};

export const handleAddEmail = (state, action) => {
  return {
    ...state,
    addEmailLoading: true,
    requestUserEmails: false,
  };
};
export const handleAddEmailSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 201) {
    return {
      ...state,
      addEmailLoading: false,
      requestUserEmails: true,
    };
  }
  return {
    ...state,
    addEmailLoading: false,
    userEmails: null,
    requestUserEmails: true,
  };
};
export const handleAddEmailFailure = (state, action) => {
  createNotification(
    "error",
    "There was an error while adding your email. Please try again.",
    3000,
  );
  return {
    ...state,
    addEmailLoading: false,
    requestUserEmails: false,
  };
};

export const handleDeleteEmail = (state, action) => {
  return {
    ...state,
    deleteEmailLoading: true,
    requestUserEmails: false,
  };
};
export const handleDeleteEmailSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 204) {
    return {
      ...state,
      deleteEmailLoading: false,
      requestUserEmails: true,
    };
  }
  return {
    ...state,
    deleteEmailLoading: false,
    userEmails: null,
    requestUserEmails: true,
  };
};
export const handleDeleteEmailFailure = (state, action) => {
  createNotification(
    "error",
    "There was an error deleting your email. Please try again.",
    3000,
  );
  return {
    ...state,
    deleteEmailLoading: false,
    requestUserEmails: false,
  };
};

export const handleMakeEmailDefault = (state, action) => {
  return {
    ...state,
    requestUserEmails: false,
  };
};
export const handleMakeEmailDefaultSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      requestUserEmails: true,
    };
  }
  return {
    ...state,
    isLoading: false,
    userEmails: null,
    requestUserEmails: true,
  };
};
export const handleMakeEmailDefaultFailure = (state, action) => {
  createNotification("error", "There was an error !! Please try again.", 3000);
  return {
    ...state,
    requestUserEmails: false,
  };
};

export const handleLogoutRequest = (state, action) => {
  return {
    ...state,
    ...initialState,
  };
};
// Account deletion status handlers
export const handleGetAccountDeleteStatus = (state, action) => {
  return {
    ...state,
    accountDeleteStatusLoading: true,
  };
};

export const handleGetAccountDeleteStatusSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      accountDeleteStatusLoading: false,
      accountDeleteStatus: data.data,
    };
  }
  return {
    ...state,
    accountDeleteStatusLoading: false,
    accountDeleteStatus: null,
  };
};

export const handleGetAccountDeleteStatusFailure = (state, action) => {
  return {
    ...state,
    accountDeleteStatusLoading: false,
    accountDeleteStatus: null,
  };
};

export const handleCancelAccountDeletion = (state, action) => {
  return {
    ...state,
    cancelDeletionLoading: true,
  };
};

export const handleCancelAccountDeletionSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200 && data.data && data.data.revoked === true) {
    createNotification("success", "Account deletion request cancelled.", 3000);
    return {
      ...state,
      cancelDeletionLoading: false,
    };
  }
  createNotification(
    "error",
    "Failed to cancel deletion request. Please contact support.",
    5000,
  );
  return {
    ...state,
    cancelDeletionLoading: false,
  };
};

export const handleCancelAccountDeletionFailure = (state, action) => {
  createNotification(
    "error",
    action?.payload?.response?.data?.detail
      ? `${action.payload.response.data.detail}. Please contact support.`
      : "Failed to cancel deletion request. Please contact support.",
    5000,
  );
  return {
    ...state,
    cancelDeletionLoading: false,
  };
};

// Action Handlers
const ACTION_HANDLERS = {
  [REQUEST_USER_PROFILE]: profileRequestHandler,
  [REQUEST_USER_PROFILE_SUCCESS]: profileRequestSuccessHandler,
  [REQUEST_USER_PROFILE_FAILURE]: profileRequestFailureHandler,
  [DELETE_ACCOUNT]: handleDeleteAccount,
  [DELETE_ACCOUNT_SUCCESS]: handleDeleteAccountSuccess,
  [DELETE_ACCOUNT_FAILURE]: handleDeleteAccountFailure,
  [GET_USER_EMAILS]: handleGetUserEmails,
  [GET_USER_EMAILS_SUCCESS]: handleGetUserEmailsSuccess,
  [GET_USER_EMAILS_FAILURE]: handleGetUserEmailsFailure,
  [ADD_EMAIL]: handleAddEmail,
  [ADD_EMAIL_SUCCESS]: handleAddEmailSuccess,
  [ADD_EMAIL_FAILURE]: handleAddEmailFailure,
  [DELETE_EMAIL]: handleDeleteEmail,
  [DELETE_EMAIL_SUCCESS]: handleDeleteEmailSuccess,
  [DELETE_EMAIL_FAILURE]: handleDeleteEmailFailure,
  [MAKE_EMAIL_DEFAULT]: handleMakeEmailDefault,
  [MAKE_EMAIL_DEFAULT_SUCCESS]: handleMakeEmailDefaultSuccess,
  [MAKE_EMAIL_DEFAULT_FAILURE]: handleMakeEmailDefaultFailure,
  [LOGIN_PROFILE_CREATED_RESET]: handleLogoutRequest,
  [GET_ACCOUNT_DELETE_STATUS]: handleGetAccountDeleteStatus,
  [GET_ACCOUNT_DELETE_STATUS_SUCCESS]: handleGetAccountDeleteStatusSuccess,
  [GET_ACCOUNT_DELETE_STATUS_FAILURE]: handleGetAccountDeleteStatusFailure,
  [CANCEL_ACCOUNT_DELETION]: handleCancelAccountDeletion,
  [CANCEL_ACCOUNT_DELETION_SUCCESS]: handleCancelAccountDeletionSuccess,
  [CANCEL_ACCOUNT_DELETION_FAILURE]: handleCancelAccountDeletionFailure,
};

// default initial state
const initialState = {
  isLoading: false,
  updateIsLoading: false,
  deleteAccountLoading: false,
  addEmailLoading: false,
  failure: false,
  userEmails: null,
  requestUserEmails: false,
  redirect: 0,
  profileData: {},
  profileDataError: "",
  accountDeleteStatus: null,
  accountDeleteStatusLoading: false,
  cancelDeletionLoading: false,
};

export default function verifyReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
